import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    cardContainer: {
        backgroundColor: theme?.mergeTable.tableCardBackground,
    },
    tableCard: {
        backgroundColor: 'transparent',
        height: '60px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: theme.spacing(0.5),
        borderColor: theme?.mergeTable.tableBorderColor,
        borderWidth: '1px',
        borderStyle: 'solid',
    },
    tableText: {
        color: theme?.mergeTable.tableTextColor,
    },
    label: {
        color: theme?.mergeTable?.textColor,
        fontWeight: '600',
        marginBottom: theme.spacing(2),
    },
    selected: {
        borderColor: theme?.mergeTable.selectedTableBorderColor,
        backgroundColor: theme?.mergeTable?.selectedTableCardBackground,
    }
}));

export default useStyles;
